import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  loadingWorkFlow: false,
  loadingCopyWorkFlow: false,
  saveLoading: false,
  workflowLength: 0,
  workflows: [],
  workflow: null,
  formErrors: '',
  error: ''
}

export default function workflowReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_WORKFLOW:
      return {...state, loadingWorkFlow: action.payload}
    case actions.LOADING_WORKFLOWS:
      return {...state, loading: action.payload}
    case actions.LOADING_COPY_WORKFLOW:
      return {...state, loadingCopyWorkFlow: action.payload}
    case actions.SAVE_LOADING_WORKFLOWS:
      return {...state, saveLoading: action.payload}
    case actions.GET_WORKFLOWS:
      return {...state, workflows: action.payload.workflows, workflowLength: action.payload.workflowLength}
    case actions.GET_WORKFLOW:
      return {...state, workflow: action.payload}
    case actions.WORKFLOW_FAIL:
      return {...state, error: action.payload}
    case actions.WORKFLOW_FORM_FAIL:
      return {...state, formErrors: action.payload}
    default:
      return state
  }
}